<template>
  <div class="index">
    <!--    <el-image aria-hidden="true" class="bgs" src="/static/image/match_result/BG1.png"></el-image>-->
    <div class="bg">

      <el-image aria-hidden="true" style="width: 40%;float: right;margin-right: 7%;margin-top: 3%" role="text"
                :src="logo"></el-image>

      <div class="main-picture">
        <p tabindex="1" id="title-p">
          <!--          <el-image role="text"  v-bind:aria-label="main_picture_label[story].text" class="title"-->
          <!--                    v-bind:src="'/static/image/match_result/figure/'+(story)+'/主图.png'"></el-image>-->

          <el-image role="text" v-bind:aria-label="main_picture_label[story].text" class="title"
                    :src="img"></el-image>
        </p>
        <div style="visibility:hidden">
          <vue-canvas-poster :widthPixels="1000" :painting="painting" @success="success"
                             @fail="fail"></vue-canvas-poster>
        </div>
      </div>
      <div class="decline">
        <el-image role="text" aria-label="继续向下滚动，查看朋友的无障碍故事" class="title"
                  src="/static/image/match_result/下滑文字.png?v=2"></el-image>
        <el-image aria-hidden="true" role="text" class="arrow"
                  src="/static/image/match_result/下滑箭头.gif"></el-image>
      </div>
      <div class="story">
                <div v-for="(item,index) in story_label">
                  <el-image role="text" v-bind:aria-label="item[story].label1" class="story-text"
                            v-bind:src="'/static/image/match_result/figure/'+(story)+'/1.png?v=2'"></el-image>
                  <el-image role="text" v-bind:aria-label="item[story].label2" class="story-text"
                            v-bind:src="'/static/image/match_result/figure/'+(story)+'/2.png?v=2'"></el-image>
                  <el-image role="text" v-bind:aria-label="item[story].label3" class="story-text"
                            v-bind:src="'/static/image/match_result/figure/'+(story)+'/3.png?v=2'"></el-image>
                  <el-image role="text" v-bind:aria-label="item[story].label4" class="story-text"
                            v-bind:src="'/static/image/match_result/figure/'+(story)+'/4.png?v=2'"></el-image>
                  <el-image role="text" aria-label="很高兴认识你，一二三，和我一起无障爱吧。" class="story-text"
                            src="/static/image/match_result/figure/0/5.png?v=2"></el-image>
                </div>



<!--        <el-image role="text" class="story-text"-->
<!--                  src="/static/image/match_result/figure/2/9.png"></el-image>-->
      </div>


      <div class="learn-more">
        <el-button aria-label="了解更多残障就业故事" @click="learn_more()"></el-button>
      </div>

      <el-image role="text" style="width: 40%;margin-left: 30%;margin-top: 10%"
                aria-label="发起方，深圳市信息无障碍研究会"
                src="/static/image/信息无障碍研究会横版logo-黑色.png?v=2"></el-image>

      <div class="cooperate">
        <p class="aaabbb">指导单位</p>
<!--        <el-image role="text" aria-label="指导单位" class="cooperate-title"-->
<!--                  src="/static/image/match_result/指导单位.png?v=2"></el-image>-->
      </div>


      <el-image role="text" class="story-text1"
                aria-label="全国无障碍环境建设智库，中国盲人协会，中国聋人协会，全国残疾人事业发展研究会无障碍环境研究专业委员会，中国残疾人事业新闻宣传促进会无障碍文化促进中心"
                src="/static/image/match_result/指导单位_文字.png?v=2"></el-image>

      <div class="cooperate">
        <p class="aaabbb">联合传播方</p>
<!--        <el-image role="text" aria-label="合作企业" class="cooperate-title"-->
<!--                  src="/static/image/match_result/合作企业.png?v=2"></el-image>-->
      </div>

      <el-image role="text" class="story-text2"
                aria-label="以下排名不分先后、微软中国、腾讯公益、讯飞输入法、讯飞听见、QQ、腾讯会议、腾讯天籁实验室、腾讯文档、微众银行、扇贝、oppo、夸克、网易有道、饿了么、天猫精灵、集光计划、樊登读书、IMPACTHUB、腾讯游戏、MTGPA、京东、闲鱼、腾讯手机管家、腾讯电脑管家、融易咨询、国金测评、博彦科技、联通畅听王卡、城市画报、爱范儿、凰家评测、雷科技、APUS、腾讯志愿者、微博共益计划、微公益、云犀、译迩科技、小白测评、声连网、中兴、nubia、红魔、星空艺术节、百度MEUX、设计思维创新实验室、小鸭嘎嘎"
                src="/static/image/match_result/合作企业logo.png?v=2"></el-image>

      <div class="btns">
        <div class="poster">
          <el-button aria-label="生成海报" @click="poster()"></el-button>
        </div>
        <div class="restar">
          <el-button aria-label="再测一次" @click="restar()"></el-button>
        </div>

<!--        <el-button aria-label="生成海报" @click="poster()">测试测试</el-button>-->

      </div>

    </div>
  </div>
</template>
<script>

import 'animate.css';
import $ from "jquery"
import Common from "../utils/Common";
import {VueCanvasPoster} from 'vue-canvas-poster'


export default {
  name: "match_result",
  data() {
    return {
      story: 0,// 选择无障碍故事
      nickname: '', // 用户昵称
      headimgurl: '', // 用户头像
      logo:'/static/image/match_result/研究会黑.png',// 研究会logo
      // 用户故事的labels
      story_label: [
        [
          {
            label1: "你好，我是你的新朋友周富贵，我来自成都，是一名视障工程师。我和你一样，喜欢聊天，喜欢挑战，喜欢创造一些好玩的东西。",
            label2: "我的工作就是通过开发一些无障碍工具，帮助残障群体更好地使用互联网产品，适应飞速发展的数字时代。经常有人问我，视障者怎么还能做工程师？怎么敲代码？作为一名低视力视障者，我一般会把电脑屏幕上的内容放大300%-400%，虽然看起来比较辛苦，但我非常享受开发和创造的乐趣。",
            label3: "工作之外，我还会逛逛CSDN、简书，刷刷B站，偶尔也会用网易有道查单词学英语。我自己就是一个信息无障碍的受益者，这也更加坚定了我做无障碍工程师的信念，通过自己的努力帮助更多残障人士，我很骄傲。",
            label4: "我一直相信，无论遇到多大的障碍，只要敢于尝试，就有成功的可能。所以，你遇到问题之后也千万不要放弃！",
          },
          {
            label1: "你好，我是你的新朋友谢昌华，我来自南阳，是一名听障外卖骑士。我和你一样，是个吃货，有理想，希望给家人更好的生活。 ",
            label2: "我是一名听障口语者，从小爸妈就教我讲口语，现在我仍旧在努力练习中。2017年，我离开嘈杂的后厨，成为一名饿了么外卖骑手，19年，饿了么捐助给我一个人工耳蜗，安静环境下我能听得更清楚了。送外卖的路上，有时候风很大，就会呼呼呼地响。",
            label3: "我知道自己比别人多了一点障碍，所以会更加努力地工作，我也经常和同事交流跑单技巧，一年之中我就只有三个差评。科技进步，我们其实是最大的受益者之一，尤其是耳蜗、助听器康复人群。希望社会能关注我们听障口语这个特殊群体，在辅具帮助下“听到声音不等于听得明白”，还请大家多一些理解和包容！",
            label4: "工作之外，我喜欢刷刷抖音、逛街、爬山，在西湖雷峰塔上看看风景，从雷峰塔上往下看的景色真是美极了。偷偷告诉你，未来，我想开一家餐厅，自己当老板！",
          },
          {
            label1: "你好，我是你的新朋友田野，我来自重庆，是一名听障创业者。我和你一样，喜欢阅读，喜欢旅游。我一直认为，聋人除了听，什么事都能做！",
            label2: "我曾经是一名设计师，为谭木匠设计产品近10年，说不定你现在还可以在谭木匠买到我的作品。后来，为了帮助更多聋人朋友更好地学习交流，我辞职创业，创办了聋听融合的手语知识无障碍分享平台“柚得”。",
            label3: "平时我也非常喜欢交朋友，和各色各样的人聊天，所以我有一些生活中不可缺少的伙伴：当沟通对象不会使用手语时，我就会先用手机中的讯飞听见来语音转文字，然后再用手机打字或纸笔与对方文字交流。对了，QQ、微信中的语音转文字也是一个非常好的功能。",
            label4: "当然，我最喜欢的还是手语，我觉得手语是一个非常优美，有意思的语言，它能拉近你我的心。未来，我会继续推广手语，帮助更多聋人或者对手语感兴趣的听人朋友，促进大家的无障碍交流。",
          },
          {
            label1: "你好，我是你的新朋友义明，目前生活在武汉，是一名肢障品牌营销人。我和你一样，喜欢运动，热衷公益，希望能在这个世界上发光发热。 ",
            label2: "可能你不相信，我真的很想参加一场马拉松，但是由于身体的问题，我只能推着轮椅参加健康跑。我之前还尝试过拳击，也很有意思，未来还想尝试很多很多不同的运动。作为刚入行的品牌营销人，我在过往的经历运营了近百场公益活动。让我印象很深的是一次少儿编程融合活动，让大家发现原来自闭症儿童除了画画也会适合少儿编程。积累的工作、生活经验让我意识到：要相信人人平等，无论是贫穷还是富裕，健全还是残障，要学会自己争取。 ",
            label3: "科技的确可以改变生活，我现在很喜欢用语音控制智能产品。每天早上用天猫精灵听听新闻，播报天气预报，设定闹钟，非常方便。我也很喜欢荣耀智能手表，可以帮我接收微信手机消息，还可以监测睡眠。 ",
            label4: "最后想和你分享的是：无论遇到什么困境，你要相信自己的选择，信念感会与你一起克服一切困难。",
          },
          {
            label1: "你好，我是你的新朋友郑锐，我来自深圳，是一名双眼只有一点点光感的短视频创作者。我和你一样，可以使用各种智能设备，会和家人朋友到处旅游，我热爱唱歌，写作，美食。 ",
            label2: "我出生在安徽蚌埠市，一出生就被查出眼睛患有牵牛花中和症，直到大学我都和明眼人一起上学，但即便我站在黑板前也看不到黑板上的字，只能回家后借同学的笔记让父母读给我听，每次完成作业都比同学多花3-4倍的时间。",
            label3: "随着科技的发展，我的生活有了翻天覆地的变化。这10年间，我从只能网上聊天听歌，到现在上班离不开微信，中午用饿了么点午餐，下班后听听樊登读书，睡前再翻一下今天微众银行买的基金赚了多少钱，看看抖音发出的视频有多少点赞评论。",
            label4: "对了，我可是个上过央视、拥有十万粉丝的抖音小网红，疫情期间，我在抖音发布了很多关于视障者如何生活的视频，让更多人了解视障者，了解信息无障碍。我想告诉大家，只要能给我们一个平等参与的机会，我们的生命一样会很精彩！",
          },
          {
            label1: "你好，我是你的新朋友Echo，我来自贵阳，是一名听障客户专员。我和你一样，充满热情，有一颗不断向上的心，想要帮助更多和我一样的听障朋友。 ",
            label2: "我刚刚毕业时，求职屡屡被拒，抱着简历会被石沉大海的心态向苹果投递了简历，大概是我面试时的热情感染了HR，现在我成为了一名苹果零售店的客户专员。无法避免的是，我跟客户的交流还是存在一些障碍。但是公司同事都很理解和包容，他们不会把我藏在背后，而是很自豪地说：这是我们的听障员工。得益于科技的力量，我可以用Airpods、讯飞听见作辅助和其他人沟通、参与会议、培训。",
            label3: "工作之外，我会学习手语，参与手语培训和公益活动。未来的目标是能成为苹果的正式员工，另外我我希望自己能够成为国内残障青年的意见领袖，在社会上为更多障碍群体发声。希望你和我一起，追逐太阳，发光发热，接触更多人，影响更多人。",
            label4: "最后，也谢谢你愿意和听障人士做朋友，我来教你一个简单的手语吧：竖起大拇指，屈几下，就是谢谢的意思。",
          },
          {
            label1: "你好，我是你的新朋友曹晟康，我来自安徽，是一名视障旅行者。我和你一样，热爱生活，喜欢交朋友，喜欢冒险，不甘于平庸，不容易屈服于现实。",
            label2: "小时候有很多人嘲笑我，说我是个没有用的人，但我努力学习正骨按摩赚钱。2008年，事业感情双双失败的我鼓起勇气去拉萨了结余生，当我站上布达拉宫，周围游客以为是信仰让我不畏艰险站在那里，纷纷为我鼓掌。我突然意识到如果我不能看见这个世界，就让这个世界看见我，从那开始我喜欢上了旅行。 后来，我踏足了38个国家、五大洲，成为中国第1个仅用三个英文单词独自环游世界的盲人。有次我去爬乞力马扎罗雪山，当时有人告诉我，上一个登顶的盲人是美国人，我想，美国人行，中国人也能行！当我成功登顶后，还抓了一把山顶的雪尝了一下，味道和我们中国的没什么不一样。",
            label3: "现在网络飞速发展，我还在继续走着，但有些东西渐渐变了。我学会了在语音提示下用我的华为手机拍照录像，它会告诉我镜头里有蓝天白云，汽车，人脸。旅行的路上我可以听QQ音乐或喜马拉雅的电台，偶尔还会刷下抖音，跟跟潮流。",
            label4: "朋友，我想告诉你，没有什么过不去的坎儿。我们要勇敢地爱自己，勇敢地走出去，努力发现、创造更多彩的人生。",
          },
          {
            label1: "你好，我是你的新朋友徐健，我来自深圳，是一名视障运营专员，管理客户投诉。我和你一样，喜欢小动物、热爱生活、爱交朋友。 ",
            label2: "我有一只可爱的导盲犬叫“呆萌”，在遇见它之前我是怕狗的，但和“呆萌”相处的过程中我慢慢地就不怕了。我在抖音上发过我和“呆萌”去公园散步的视频，有评论问：瞎子为什么要去公园散步，给狗看风景吗？我想说，我也是有七情六欲的人，我也想感受生活。",
            label3: "我尝试过很多不同的职业，包括幼师、残疾人艺术团声乐演员、节目主播等等。幸运的是，现在的公司为了我改进很多，比如电梯加了盲文按钮，同事在与我沟通时也会用文字注解图片。",
            label4: "我应该属于第一批接触前沿技术的视障人士了，00年的时候，用手机和电脑都觉得很新奇。现在，我可以通过读屏软件熟练地使用微信、QQ邮箱、百度、滴滴打车、抖音、微信读书等等，可以说科技极大地改变了我们感受世界的方式。 最后想告诉大家，希望大家能够平等地看待我们，享受生活的方式有很多种，我们也有自己的热爱。",
          },
          {
            label1: "你好，我是你的新朋友沈丞晴，我来自天津，是一名多重障碍学生。我和你一样，热爱生活，满腔热血，希望能够尽自己的力量改变世界。 ",
            label2: "我是多重障碍者，除了需要坐轮椅之外，现在听力也越来越差。只能使用一些科技手段支持我的日常生活，比如智能手环，智能家居，能解决很多小麻烦。虽然环境有很多不便，但我还是对未来的生活充满了热情和信心。",
            label3: "我创立了少数派团队，做的一直是残障社群成员的支持倡导工作，鼓励他们出门、求学、就业。未来比较想做残障朋友接触自然的公益活动。我特别喜欢参加或组织各种需要残障人士走出来接触大自然的公益活，尤其是对一些残障儿童来说，要多去触摸东西，才能更好地感受这个世界。展望未来，考虑到身体因素，我觉得求职对我而言应该是一个比较大的困难，但我会继续努力，积累经验，或许创业也是一个不错的选择~",
            label4: "希望从你我开始，我们减少对残障人士的偏见，多去了解和接触与自己不同的人和事，并且把这个态度倡导出去，传递更多的正能量，每个人的一点改变都对这个社会都很重要。 ",
          },


        ]
      ],
      // 用户主图
      main_picture_label: [
        {
          text: "Hi，原来你的人格类型是：爱自己，你是一个懂自己、爱自己的人  一切随心，敢爱敢恨！，与你匹配度最高的专属朋友是，周富贵，他的标签是：视障工程师；我为自己骄傲，他说：我是信息无障碍受益者，更是信息无障碍推动者。继续向下滑动，查看朋友的无障爱故事，",
        },
        {
          text: "Hi，原来你的人格类型是：爱自己，你是一个懂自己、爱自己的人  一切随心，敢爱敢恨！与你匹配度最高的专属朋友是，谢昌华，他的标签是：听障外卖骑士；有上进心的乐天派，他说：任风声喧嚣障碍重重，脚踏实地追求新生活，继续向下滑动，查看朋友的无障爱故事， ",
        },
        {
          text: "Hi，原来你的人格类型是：爱自己，你是一个懂自己、爱自己的人  一切随心，敢爱敢恨！与你匹配度最高的专属朋友是，田野，他的标签是：听障创业者；手语宣传大使；靠谱，他说：聋人除了听，什么都能做！继续向下滑动，查看朋友的无障爱故事，",
        },
        {
          text: "Hi，原来你的人格类型是：爱他人，你是一个会分享、爱他人的人  你爱朋友，朋友爱你！与你匹配度最高的专属朋友是，义明，他的标签是：肢障品牌营销人；爱公益；爱折腾；爱旅行，他说：无论健全还是残障，要为自己的人生不断增彩！继续向下滑动，查看朋友的无障爱故事， ",
        },
        {
          text: "Hi，原来你的人格类型是：爱他人，你是一个会分享、爱他人的人  你爱朋友，朋友爱你！与你匹配度最高的专属朋友是，郑锐，他的标签是：视障短视频创作者；资深手机玩家，他说：给我一个平等的机会，我可以一样出彩，继续向下滑动，查看朋友的无障爱故事， ",
        },
        {
          text: "Hi，原来你的人格类型是：爱他人，你是一个会分享、爱他人的人  你爱朋友，朋友爱你！与你匹配度最高的专属朋友是，赵婉婷Echo，他的标签是：听障客户专员；热血青年；自信放光芒，他说：用指尖传递美好与包容，继续向下滑动，查看朋友的无障爱故事， ",
        },
        {
          text: "Hi，原来你的人格类型是：爱生活，你是一个无杂念、爱生活的人  天大地大，快乐最大！与你匹配度最高的专属朋友是，曹晟康，他的标签是：全盲旅行者；世界那么大，我想走个遍，他说：如果我不能看见这个世界，就让这个世界看见我，继续向下滑动，查看朋友的无障爱故事，",
        },
        {
          text: "Hi，原来你的人格类型是：爱生活，你是一个无杂念、爱生活的人  天大地大，快乐最大！与你匹配度最高的专属朋友是，徐健，他的标签是：视障运营专员；温暖优雅呆萌姐，他说：我看不见大海波澜壮阔，但能感受海风潮湿沙子细软，继续向下滑动，查看朋友的无障爱故事， ",
        },
        {
          text: "Hi，原来你的人格类型是：爱生活，你是一个无杂念、爱生活的人  天大地大，快乐最大！与你匹配度最高的专属朋友是，沈丞晴，他的标签是：多重障碍者；还是个学生；青年有为，他说：打破偏见，没有什么障碍能阻止我前进，继续向下滑动，查看朋友的无障爱故事，",
        }
      ],
      painting: {
        width: '1000px',
        height: '1650px',
        // background: '#f4f5f7',
        views: [
          {
            type: 'image',
            url: "",
            css: {
              width: '1000px',
              height: '1650px',
            }
          },
          {
            type: 'image',
            url: Common.headimgurl,
            // url:"https://www.sunniejs.cn/static/avatar.png",
            css: {
              top: '30px',
              left: '25px',
              borderRadius: '100%',
              width: '200px',
              height: '200px',
              borderWidth: '6px',
              borderColor: '#f5f5f5'
            }
          },
          {
            type: 'text',
            text: "hi~" + Common.nickname,
            // text:"hi~富贵Rich富贵Rich富贵Rich富贵Rich",
            css: {
              top: '260px',
              left: '25px',
              width: '500px',
              maxLines: 1,
              fontSize: '35px',
              // fontWeight: '500'
            }
          },
          {
            type: 'text',
            text: "原来你的人格类型是...",
            css: {
              top: '330px',
              left: '25px',
              width: '550px',
              maxLines: 1,
              fontSize: '35px',
              // fontWeight: '500'
            }
          },
        ],
      },
      img: "/static/image/match_result/figure/0/主图.png",
    }
  },

  mounted() {
    this.story = localStorage.getItem("story")
    this.painting.views[0].url = require("../../../static/image/match_result/figure/" + this.story + "/主图.png")
    if (this.story <= 2) {
      this.logo = "/static/image/match_result/研究会黑.png"
      $(".index").css({"background-image": "url('/static/image/match_result/BG1.png?v=3')"})
    } else if (this.story >= 3 && this.story <= 5) {
      this.logo = "/static/image/match_result/研究会白.png"
      $(".index").css({"background-image": "url('/static/image/match_result/BG2.png?v=3')"})
    } else {
      this.logo = "/static/image/match_result/研究会白.png"
      $(".index").css({"background-image": "url('/static/image/match_result/BG3.png?v=3')"})
    }


    this.$nextTick(function () {


      // 获取元素距离顶部的距离跟可视区域的高度
      const h = screen.height
      const w = screen.width
      if (w <= 500) {
        if (h <= 600) {
          // 用户信息
          $(".avatar").css({"width": "50px", "height": "50px", "top": "6%"})
          $(".nick_name").css({"top": "9.5%"})
          $(".personality").css({"top": "11%"})
          // 了解更多按钮
          // $(".learn-more > .el-button").css({"height": "25px", "margin-left": "35%", "width": "30%"})
        } else if (h > 600 && h <= 700) {
          // 用户信息
          $(".avatar").css({"width": "70px", "height": "70px", "top": "6%"})
          $(".nick_name").css({"top": "10.5%"})
          $(".personality").css({"top": "12%"})
        } else if (h > 700 && h <= 800) {
          // 用户信息
          $(".avatar").css({"width": "70px", "height": "70px", "top": "6%"})
          $(".nick_name").css({"top": "10%"})
          $(".personality").css({"top": "11%"})
        } else if (h > 800 && h <= 900) {
          // 用户信息
          $(".avatar").css({"width": "75px", "height": "75px", "top": "6%"})
          $(".nick_name").css({"top": "10.5%"})
          $(".personality").css({"top": "12%"})
        } else if (h >= 900) {
          // 用户信息
          $(".avatar").css({"width": "50px", "height": "50px", "top": "6%"})
          $(".nick_name").css({"top": "9.5%"})
          $(".personality").css({"top": "11%"})
          // 了解更多按钮
          // $(".learn-more > .el-button").css({"height": "25px", "margin-left": "35%", "width": "30%"})
        }
      } else {
        console.log(h)
        if (h >= 900) {

          $(".learn-more > .el-button").css({"width": "441px","height": "55px"})


          $(".story-text1").css({"margin-top":"50px"})
          $(".poster > .el-button").css({"width": "170px", "height": "70px"})
          $(".restar > .el-button").css({"width": "170px", "height": "70px"})
          $(".story").css({"margin-top":"50px"})
          // 了解更多按钮
          // $(".learn-more > .el-button").css({"height": "30px", "margin-left": "40%", "width": "20%"})
        }
      }
      document.getElementById('title-p').focus()
      this.nickname = Common.nickname
      this.headimgurl = Common.headimgurl


    })
  },
  methods: {
    success(src) {
      this.img = src
    },
    fail(err) {
      console.log('fail', err)
    },
    // 生成海报
    poster() {
      this.$router.replace('/poster')
    },

    // 了解更多
    learn_more() {
      window.location.replace("https://mp.weixin.qq.com/s/I7N-PdJz-UMgRC_EkdcNbw")
    },

    // 再测一次
    restar() {
      this.$router.replace('/game')
    }
  },
  components: {
    VueCanvasPoster,
  },
}
</script>


<style scoped>


.index {
  height: auto;
  /*background: #3a8ee6;*/
  /*height: 100vh;*/
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

.bg {
  position: relative;
  z-index: 1;
  top: 1px;
  padding-bottom: 20%;
}


.main-picture {
  padding-top: 30%;
  width: 87%;
  margin-left: 13%;
}

.decline {
  margin-top: 10px;
  width: 70%;
  margin-left: 15%;
  margin-bottom: -10%;
}

.cooperate {
  margin-top: 1rem;
  text-align: center;
}

.story {
  padding-top: 14%;
  width: 70%;
  margin-left: 15%;
}




.nick_name {
  width: 35%;
  position: absolute;
  font-size: 14px;
  top: 11.5%;
  left: 15%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.personality {
  position: absolute;
  font-size: 14px;
  top: 12.5%;
  left: 15%;
}

.avatar {
  position: absolute;
  font-size: 12px;
  top: 7%;
  left: 15%;
  border-radius: 50%;
  width: 75px;
  height: 75px;
  border: 1px solid #5f5f5f;
}


.btns {
  text-align: center;
  letter-spacing: 0.8rem;
  margin-bottom: 10%;
}

.arrow {
  margin-top: -10%;
  width: 10%;
  margin-left: 45%;
}


/*去掉获得焦点的边框*/
p {
  outline: none;
}

.learn-more{
  margin-top: -20px;
  width: 100%;
  text-align: center;
}


.learn-more > .el-button {
  text-align: center;
  width: 210.5px;
  height: 27.5px;
  background: url("/static/image/match_result/了解更多.png?v=2");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  border: none;
}

.restar > .el-button {
  width: 110px;
  height: 40px;
  background: url("/static/image/match_result/再测一次.png?v=2");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  border: none;
}

.poster > .el-button {
  width: 110px;
  height: 40px;
  background: url("/static/image/match_result/生成海报.png?v=2");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  border: none;
}


.poster {
  display: inline-block;
  width: 30%;
  margin-top: 30px;
}

.restar {
  display: inline-block;
  width: 30%;
  margin-top: 30px;
}

.story-text {
  margin-top: -5px;
  /*pointer-events: none;*/
}


.story-text1 {
  margin-top: 0.5rem;
  width: 70%;
  margin-left: 15%;
}

.story-text2{
  margin-top: 0.5rem;
  width: 85%;
  margin-left: 7.5%;
}


@font-face {
  font-family:wending;
  src:url("/static/font/PANGMENZHENGDAOBIAOTITI.TTF");
}

.aaabbb{
  text-align: center;
  font-size:0.5rem;
  font-family:wending;
}


</style>




// WEBPACK FOOTER //
// src/components/home/match_result.vue